module.exports = __webpack_public_path__ + "img/Package.5bf3d04a.png";